export default __webpack_public_path__ + "static/media/offers-heading.abfe4537.png";